import Vue from 'vue'
import Vuex from 'vuex'
import auth from "@/api/auth";
import user from "@/api/user";
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: auth.getToken() || "",
    user: {}
  },
  getters: {
    auth(state) {
      return state.token;
    },
    user(state){
      return state.user
    }
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token;
    }
  },
  actions: {
    login({ commit }, Login) {
      return new Promise((resolve, reject) => {
        user.login({
          token: Login.token,
          email: Login.email,
          password: Login.password
        })
          .then(res => {
           
            if(!res.data.token){
              return resolve("Invalid token");
            }else{
              commit("SET_TOKEN", res.data.token);
              auth.setToken(res.data.token);
              resolve();
            }
     
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    logout({ commit }) {
      commit("SET_TOKEN", "");
      auth.removeToken()
    }
  },
  modules: {
  }
})
